import {
  SITE_IMAGES_LIST_REQUEST,
  SITE_IMAGES_LIST_SUCCESS,
  SITE_IMAGES_LIST_FAIL,
  SITE_IMAGE_UPSERT_SUCCESS,
  SITE_IMAGE_UPDATE_SUCCESS,
  SITE_IMAGE_DELETE_SUCCESS,
} from "../constants/siteImageConstants";

const initial = {
  loading: false,
  error: null,
  images: [],
  imagesMap: {}, // { key: doc }
};

export const siteImagesReducer = (state = initial, action) => {
  switch (action.type) {
    case SITE_IMAGES_LIST_REQUEST:
      return { ...state, loading: true, error: null };
    case SITE_IMAGES_LIST_SUCCESS: {
      const { images = [], map = {}, queriedKeys = null } = action.payload || {};
      // When the action carries queriedKeys, the server response is
      // authoritative for those keys: drop any old entries for them
      // (e.g., a key that was just deleted) and replace with what the
      // server returned. Other keys in imagesMap are preserved so a
      // partial fetch (e.g., only ["vision1"]) doesn't wipe the hero.
      let nextImagesMap;
      if (queriedKeys && queriedKeys.length > 0) {
        nextImagesMap = { ...state.imagesMap };
        for (const k of queriedKeys) delete nextImagesMap[k];
        nextImagesMap = { ...nextImagesMap, ...map };
      } else {
        // Fetched ALL — replace map entirely so deletions propagate.
        nextImagesMap = { ...map };
      }
      return { ...state, loading: false, images, imagesMap: nextImagesMap };
    }
    case SITE_IMAGES_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };

    case SITE_IMAGE_UPSERT_SUCCESS: {
      const img = action.payload;
      const images = [
        ...state.images.filter((i) => i._id !== img._id && i.key !== img.key),
        img,
      ];
      const imagesMap = { ...state.imagesMap, [img.key]: img };
      return { ...state, images, imagesMap };
    }

    case SITE_IMAGE_UPDATE_SUCCESS: {
      const img = action.payload;
      const images = state.images.map((i) => (i._id === img._id ? img : i));
      const imagesMap = { ...state.imagesMap, [img.key]: img };
      return { ...state, images, imagesMap };
    }

    case SITE_IMAGE_DELETE_SUCCESS: {
      const id = action.payload;
      const images = state.images.filter((i) => i._id !== id);
      // rebuild map without deleted entry
      const imagesMap = {};
      for (const i of images) imagesMap[i.key] = i;
      return { ...state, images, imagesMap };
    }

    default:
      return state;
  }
};
